import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { fullName } from '../../../common/helpers/users';
import { setCustomer } from '../../customer/actions';
import withToggle from '../../../common/hoc/withToggle';
import NewCustomer from '../components/NewCustomer';

const NewCustomerContainer = compose(
  connect(null, { setCustomer }),
  withToggle(),
  withHandlers({
    onAfterSubmit: props => (customer) => {
      props.off();
      props.setCustomer({ ...customer, name: fullName(customer) });
    },
  })
)(NewCustomer);

export default NewCustomerContainer;
